import React, { Component, Fragment } from 'react'
import { homeRedUpdate } from "../../Actions/HomeAction"


const discountBadge = (tour, dis_value) => {
    var bedge = dis_value > 0 ? "corner-ribbon top-left sticky red shadow" : ""
    var dis_type = tour.item_discount !== undefined && tour.item_discount.discount != undefined ? tour.item_discount[0].discount.dis_type : null

    if (dis_type == 0) {
        bedge = "corner-ribbon top-left sticky red shadow"
    } else if (dis_type == 1) {
        bedge = "corner-ribbon-login top-left sticky shadow"
    } else if (dis_type == 2) {
        bedge = "corner-ribbon-share top-left sticky shadow"
    }

    return bedge
};


function getCategoryName(tour) {
    var name = ""
    switch (tour.tour) {
        case "Day tour":
            name = tour.day_location.length > 0 ? tour.day_location[0].city.name : "Contact for more info"
            break;
        case "Round tour":
            name = tour.itinerary_category.name
            break;
        case "Maldive tour":
            name = tour.type_id == 1 ? 'Resort' : 'Package'
            break;

        default:
            break;
    }
    return name
}


function getTourDate(tour) {
    var dateBegin = new Date()
    var dateEnd = new Date()
    switch (tour.tour) {
        case "Day tour":
            dateBegin = new Date(tour.from_date)
            dateEnd = new Date(tour.to_date)
            break;
        case "Round tour":
            dateBegin = new Date(tour.from_price_date)
            dateEnd = new Date(tour.to_price_date)
            break;

        default:
            break;
    }
    return { dateBegin, dateEnd }
}


function getMaxValue(tour) {
    var max = null
    var to_number = 0
    switch (tour.tour) {
        case "Day tour":
            for (let i = 0; i < tour.day_location[0].location_group_cost.length; i++) {
                var loc = tour.day_location[0].location_group_cost[i]
                if (loc.type == 0 && loc.to_number > to_number) {
                    max = loc
                    to_number = loc.to_number
                }
            }
            break;
        case "Round tour":
            if (tour.itinerary_season.length > 0) {
                for (let i = 0; i < tour.itinerary_season.length; i++) {
                    const season = tour.itinerary_season[i]
                    const seasonStart = season.season_itinerary != undefined ? new Date(season.season_itinerary.start_date) : null
                    const seasonEnd = season.season_itinerary != undefined ? new Date(season.season_itinerary.end_date) : null
                    const today = new Date()

                    if (seasonStart <= today && seasonEnd > today) {
                        for (let j = 0; j < season.seasonal_group_cost.length; j++) {
                            const cost = season.seasonal_group_cost[j]
                            if (cost.type == 0 && cost.to_number > to_number) {
                                max = cost
                                to_number = cost.to_number
                            }
                        }
                    }
                }
            }
            break;

        default:
            break;
    }
    return max
}



function getDiscountedValue(tour, max) {
    var dis_price = 0
    if (tour.tour == "Maldive tour") {
        dis_price = tour.tour_price.discount.price != undefined ? tour.tour_price.discount.price : 0
    } else {
        var actual_price = max.price
        var discount = actual_price * tour.item_discount[0].discount.disc_value / 100

        dis_price = actual_price - discount

    }
    
    return Number(dis_price.replace(/,/g, '')).toFixed(2)
}


function getTitle(tour) {
    var title = ""
    switch (tour.tour) {
        case "Day tour":
            title = tour.title
            break;
        case "Round tour":
            title = tour.name
            break;
        case "Maldive tour":
            title = tour.title
            break;

        default:
            break;
    }

    title = title.length > 38 ? title.substring(0, 38) + "..." : title

    return title
}


function getPeragraph(tour) {
    var Pera = ""
    switch (tour.tour) {
        case "Day tour":
            Pera = tour.content

            break;
        case "Round tour":
            Pera = tour.description
            break;
        case "Maldive tour":
            Pera = tour.description
            break;

        default:
            break;
    }

    Pera = Pera.length > 100 ? Pera.substring(0, 100) + "..." : Pera

    return Pera
}


function getImageBedge(tour) {
    var Pera = ""

    switch (tour.tour) {
        case "Day tour":
            for (let i = 0; i < tour.day_tour_categories.length; i++) {
                var cat = tour.day_tour_categories[i]
                if (cat.category != undefined && cat.category.name != "" && i <= 1) {
                    Pera = Pera + cat.category.name
                    if (i < 1 && i + 1 != tour.day_tour_categories.length) {
                        Pera = Pera + " , "
                    }
                }
            }
            break;
        case "Round tour":
            Pera = tour.itinerary_days.length + " Days " + (tour.itinerary_days.length - 1) + " Nights"
            break;

        default:
            break;
    }

    return Pera
}

function getDiscValue(tour) {
    var value = 0
    if (tour.tour == "Day tour" || tour.tour == "Round tour") {
        if (tour.item_discount != undefined && tour.item_discount.length > 0 && tour.item_discount[0].discount != undefined) {
            value = tour.item_discount[0].discount.disc_value
        }
    } else if (tour.tour == "Maldive tour") {
        if (tour.tour_price.discount.length > 0) {
            value = tour.tour_price.discount.value
        }
    }


    return value
}

function getDiscTypebedge(tour) {
    var bedge = "corner-ribbon top-left sticky red shadow"

    switch (tour.discount_type) {
        case 0:
            bedge = "corner-ribbon top-left sticky red shadow"
            break;
        case 1:
            if (tour.login) {
                bedge = "corner-ribbon-login top-left sticky shadow"
            }
            break;
        case 2:
            bedge = "corner-ribbon-share top-left sticky shadow"
            break;

        default:
            break;
    }

    return bedge
}

function getDiscountLable(tour) {
    var bedge = ""

    switch (tour.discount_type) {
        case 0:
            bedge = " OFF"
            break;
        case 1:
            if (tour.login) {
                bedge = <br /> + "LOGIN & GET"
            }
            break;
        case 2:
            bedge = <br /> + "SHARE & GET"
            break;

        default:
            break;
    }

    return bedge
}


class MaldiveTourList extends Component {

    constructor(props) {
        super(props);
        var tour = this.props.tour
        this.state = {
            today: new Date(),
            fromDiscountDate: tour.item_discount != undefined && tour.item_discount.length > 0 && tour.item_discount[0].discount != undefined ? new Date(tour.item_discount[0].discount.from_discount_date) : new Date(),
            toDiscountDate: tour.item_discount != undefined && tour.item_discount.length > 0 && tour.item_discount[0].discount != undefined ? new Date(tour.item_discount[0].discount.to_discount_date) : new Date(),
            disc_value: getDiscValue(tour),

            dateBegin: getTourDate(tour).dateBegin,
            dateEnd: getTourDate(tour).dateEnd,
            max: getMaxValue(tour)
        }
    }
    
    render() {
        var tour = this.props.tour
        return <Fragment>
            <div className="col-lg-3" data-aos="fade-up"
                data-aos-delay={(this.props.key % 4) * 150} data-aos-id={this.props.key}>
                <div className="card tc-item-update rout-tur wow fadeInUp">
                    <a href={this.props.url} >
                        <div className="tourbox" style={{ backgroundImage: `url(` + this.props.bgImage + `)` }}>
                            {tour.discountPrice != undefined && tour.discountPrice > 0 ?
                                <div className={getDiscTypebedge(tour)}>
                                    <b>{tour.discount_new}%{getDiscountLable(tour)}</b>
                                </div>
                                : <>
                                    {this.state.disc_value > 0 && this.state.fromDiscountDate <= this.state.today && this.state.toDiscountDate > this.state.today ?
                                        <div className={discountBadge(tour,this.state.disc_value)}>{this.state.disc_value}% OFF</div> : null
                                    }
                                </>}

                            {tour.tour == "Maldive tour" && tour.tour_price.discount.price != undefined ?
                                <div className="corner-ribbon top-left sticky red shadow"> {tour.tour_price.discount.value}% OFF </div>
                                : null}

                            {tour.tour == "Maldive tour" && tour.tour_price.offer != "" ?
                                <div className="corner-ribbon top-left sticky red shadow">OFFER</div>
                                : null}

                            {tour.rating != 0 ? <div className="tour-rating-badge"><span>{tour.rating > 0 ? tour.rating : 0}</span>Rating</div> : <div className="tour-rating-badge"><span>No</span>Ratings yet</div>}
                            <div className="touritemwrap-update">
                                <div className="tourbox-bottom">
                                    <div className="tourbox-bottom-col1">{getCategoryName(tour)}</div>
                                    {tour.stars > 0 ?
                                        <div className="tourbox-bottom-col2 star-align">
                                            <div className="star-rating" title="100%">
                                                <div className="back-stars">
                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                    <i className="fa fa-star" aria-hidden="true"></i>

                                                    <div className="front-stars" style={{ width: (tour.stars / 5) * 100 + "%" }}>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null}

                                </div>
                            </div>

                        </div>
                        {tour.tour_price.price > 0 ? <div className="pricetag-search">
                            <span className="pricetagtitle">Starting from</span>
                            <div className="price-tag">
                                {tour.tour_price.discount.price != undefined ?
                                    <> <strike style={{ fontSize: 14 }}>USD {Number(tour.tour_price['price']).toFixed(2)}</strike><br /> USD {getDiscountedValue(tour, tour.tour_price)}
                                    </>
                                    : <>USD {Number(tour.tour_price['price']).toFixed(2)}</>}
                            </div>
                        </div> : <div class="pricetag-no-publish">
                            <div className="day-tour-days-red-search" style={{ backgroundColor: "#f33e3e" }}>Contact for pricing</div>
                        </div>}

                        <div className="cardinfo" >
                            <h4>{getTitle(tour)}</h4>
                            {tour.tour == "Day tour" || tour.tour == "Round tour" ? <div> <small> {getImageBedge(tour)} </small> </div> : null}

                            <div
                                dangerouslySetInnerHTML={{ __html: getPeragraph(tour) }}
                            />
                        </div>
                    </a>
                </div>
            </div>
        </Fragment>
    }
}


export default MaldiveTourList;